import ImportImages from '@src/importImages';

const RedFlower = ImportImages('/partners/red-flower.png');
const Coyuchi = ImportImages('/partners/coyuchi.png');
const Venus = ImportImages('/partners/Venus et Fleur.png');
//const Dean = ImportImages('/partners/Dean and Deluca.png');
const Diptyque = ImportImages('/partners/Diptyque.png');
const Fury = ImportImages('/partners/for the fury.png');
const Blade = ImportImages('/partners/BLADE.png');
const Torn = ImportImages('/partners/TornRanch_logo_bw.jpg');
const Embark = ImportImages('/partners/embark.png');

export const refreshData = {
  id: 'refreshment-items',
  className: 'panel d-flex align-items-center',
  mainContent: {
    id: 0,
    header: 'Partners',
    content:
      'Discover the premium benefits our partners offer clients of JetSuite.'
  },
  boxes: [
    {
      id: 7,
      title: '',
      titleImg: {
        src: Blade,
        alt: 'BLADE'
      },
      header: 'BLADE',
      content: `Through exclusive access to our preferred helicopter partner BLADE, clients can arrive plane-side with precision and style.`,
      link: {
        url: 'https://blade.flyblade.com/',
        label: 'Learn More',
        target: '_blank'
      }
    },
    {
      id: 2,
      title: '',
      titleImg: {
        src: Coyuchi,
        alt: 'Coyuchi'
      },
      header: 'Coyuchi',
      content: `Wrap yourself in the comfort of Coyuchi's organic blanket onboard our aircraft.`,
      link: {
        url: 'https://www.coyuchi.com',
        label: 'Learn More',
        target: '_blank'
      }
    },
    /*{
      id: 4,
      title: '',
      titleImg: {
        src: Dean,
        alt: 'Dean and Deluca'
      },
      header: 'Dean & Deluca',
      content: `Dean & Deluca's gourmet assortment of snacks served onboard our aircraft.`,
      link: {
        url: 'https://www.deandeluca.com/',
        label: 'Learn More',
        target: '_blank'
      }
    },*/
    {
      id: 5,
      title: '',
      titleImg: {
        src: Diptyque,
        alt: 'Diptyque'
      },
      header: 'Diptyque',
      content: `The warmth of fig wood, the freshness of its leaves and the milky sap highlight our signature onboard cabin scent - Figuier by Diptyque.`,
      link: {
        url: 'https://www.diptyqueparis.com/',
        label: 'Learn More',
        target: '_blank'
      }
    },
    {
      id: 6,
      title: '',
      titleImg: {
        src: Fury,
        alt: 'For the Furry'
      },
      header: 'For the Furry',
      content: `The best style for your fur child. Curated pet amenities by For the Furry onboard our aircraft.`,
      link: {
        url: 'https://forthefurry.com/',
        label: 'Learn More',
        target: '_blank'
      }
    },
    {
      id: 1,
      title: '',
      titleImg: {
        src: RedFlower,
        alt: 'Red Flower'
      },
      header: 'Red Flower',
      content: `Your home away from home. Experience organic skincare products curated by Red Flower onboard our aircraft.`,
      link: {
        url: 'https://redflower.com',
        label: 'Learn More',
        target: '_blank'
      }
    },
    {
      id: 3,
      title: '',
      titleImg: {
        src: Venus,
        alt: 'Venus et Fleur'
      },
      header: 'Venus et Fleur',
      content: `Adding a touch of elegance and style onboard our aircraft.`,
      link: {
        url: 'https://www.venusetfleur.com/',
        label: 'Learn More',
        target: '_blank'
      }
    },
    {
      id: 8,
      title: '',
      titleImg: {
        src: Torn,
        alt: 'Torn Ranch'
      },
      header: 'Torn Ranch',
      content: `A new line of onboard snacks curated by gourmet foods purveyor Torn Ranch.`,
      link: {
        url: 'https://www.tornranch.com',
        label: 'Learn More',
        target: '_blank'
      }
    },
    {
      id: 9,
      title: '',
      titleImg: {
        src: Embark,
        alt: 'Embark'
      },
      header: 'Embark',
      content: `A luxury travel advisory dedicated to creating thoughtfully designed experiences that go beyond a destination.`,
      link: {
        url: 'https://embarkbeyond.com/',
        label: 'Learn More',
        target: '_blank'
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Partners/refresh-data.js